export default __webpack_public_path__ + "static/media/services.f5a0144f.png";